import { Ergebnisse } from "../ws/ergebnis/ergebnisse.model";
import { Gebaeude } from "../ws/dbKlassen/gebaeude.model";

export class TableSelectGebaeude {
  bezeichnung!: string;
  galerie!: string;
  plaene!: string;
  gebaeude!: Gebaeude;
  idGebaeude!: number;
 

  public static getTableSelectGebaeudeList(
    ergebnisse: Ergebnisse
  ): TableSelectGebaeude[] {
    if (ergebnisse.ergebnisGebaeudeList.length == 0)
      return [];

    let tableSelectGebaeude: TableSelectGebaeude[] = [];
    let tmp!: TableSelectGebaeude;
 
    ergebnisse.ergebnisGebaeudeList.forEach((entry, i) => {
      if (i === 0 && ergebnisse.ergebnisGebaeudeList.length > 1) {
        // Überspringe den ersten Eintrag
        return;
      }

         if (tmp) {
          tableSelectGebaeude.push(tmp);
        }
        tmp = new TableSelectGebaeude();
        tmp.bezeichnung = entry.gebaeude.bezeichnung;
        tmp.idGebaeude = entry.gebaeude.idGebaeude;
        tmp.gebaeude = entry.gebaeude;
    
    });

    // Prüfen, ob tmp noch vorhanden ist, und es zum Array hinzufügen
    if (tmp) {
      tableSelectGebaeude.push(tmp);
    }
  

    return tableSelectGebaeude;
  }
}